import * as React from "react";
import {
    Skeleton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    useTheme,
} from "@mui/material";

interface TableSkeletonProps {
    row?: number;
    column?: number;
}

export default function TableSkeleton({
    row = 7,
    column = 7,
}: TableSkeletonProps) {
    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        {[...Array(column)].map((_, index) => (
                            <TableCell key={index} sx={{ height: "49px" }}>
                                <Skeleton variant="text" />
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {[...Array(row)].map((_, rowIndex) => (
                        <TableRow key={rowIndex}>
                            {[...Array(column)].map((_, colIndex) => (
                                <TableCell
                                    key={colIndex}
                                    sx={{ height: "39px" }}
                                >
                                    <Skeleton variant="text" />
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export const TableSkeletonWithoutHeader = ({
    row = 11,
    column = 5,
}: TableSkeletonProps) => {
    const theme = useTheme();

    return (
        <TableContainer
            sx={{ backgroundColor: theme.palette.background.paper }}
        >
            <Table>
                <TableBody>
                    {[...Array(row)].map((_, rowIndex) => (
                        <TableRow key={rowIndex}>
                            {[...Array(column)].map((_, colIndex) => (
                                <TableCell
                                    key={colIndex}
                                    sx={{ height: "55px" }}
                                >
                                    <Skeleton variant="text" />
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
